import React, { useContext, useEffect, useState } from 'react'
import CarteRechargeMobile from './carteRechargeMobile'
import RechargeContext from 'contexts/rechargeContext'

import { useNavigate } from 'react-router-dom'

import classNames from 'classnames'
import UserContext from 'contexts/UserContext'
import ModalTestStatusUser from 'components/modalTestStatusUser'

  import {PROVIDERCONFIG} from '../rechargeContainer/ProviderRecharge'

interface CarteRecharge {
  ProviderCode: string
  SkuCode: string
  LocalizationKey: string
  SettingDefinitions: any[] 
  Maximum: {
    SendCurrencyIso: number
    ReceiveCurrencyIso: string
    ReceiveValueExcludingTax?: number
    SendValue: string
    ReceiveValue: string

  }
}
interface Props{
  listeCarte: CarteRecharge[]
  onBackChangeStep: ()=>void
  onChangeStep: ()=>void
  setListeCarte: React.Dispatch<React.SetStateAction<CarteRecharge[]>>
  FNPayer: any
  functionTracks: any
  // setIconOperateur:(icon:string)=>void

}
const OffreRecharge  : React.FC <Props> = ({
  listeCarte, onBackChangeStep, onChangeStep, 
  setListeCarte, FNPayer, functionTracks,
  // setIconOperateur
}) => {

const {user} = useContext(UserContext)
  const {recharges ,setRecharges}=useContext(RechargeContext)
  const statusComplete = user?.user?.status === 'confirmed' && user?.user?.isDocumentSent
  const statusPending = user?.user?.status === 'pending' && user?.user?.isDocumentSent
  const statusNotFound = user?.user?.status === 'pending' && !user?.user?.isDocumentSent

  const navigate = useNavigate()

  const [openIsModalStatus, setOpenIsModalStatus] = useState(false)

  const openModalStatus = () => {
    setOpenIsModalStatus(true)
  }
  const closeModalStatus = () => {
    setOpenIsModalStatus(false)
  }
  const [selectedIndex, setSelectedIndex] = useState<number>(-1)

  const provider = listeCarte?.[0]?.ProviderCode
  const Carte=PROVIDERCONFIG[provider] || {}


   
  const handleSelect=( select : any, index: number)=>{
    setRecharges({
      ...recharges,
      MontantTnd: select.Maximum.SendCurrencyIso,
      MontantDinar: select.Maximum.ReceiveValue,
      MontantEur: select.Maximum.SendValue,
      ReceiveValueExcludingTax:select.Maximum.ReceiveValueExcludingTax,
      indexRechargeTN: index,
      SkuCode: select.SkuCode,
      isOn: true,
      iconOperateur:Carte.icon,
      ReceiveCurrencyIso:select.Maximum.ReceiveCurrencyIso
          })
     setSelectedIndex(index)

  }


  return (
    <div className=' flex flex-col items-center  w-full  '>
      <div className='flex flex-wrap gap-4 max-h-[500px] overflow-y-auto scrollbar-webkit sm:scrollbar-hide  w-full py-5'>
        {listeCarte.map((item:CarteRecharge, index:number)=>
          {
            if (!item) return null 

            return (
          <div className=' mx-auto  sm:mx-5 sm:w-full' key={index} >
          
            <CarteRechargeMobile
            logo={Carte.logo}
            widthLogo={Carte.width}
            styleText={Carte.styleText}
            montantCarte={item.Maximum.ReceiveValue}
            ReceiveValueExcludingTax={item.Maximum.ReceiveValueExcludingTax}
            ReceiveCurrency={item.Maximum.ReceiveCurrencyIso}

            montantpayer={item.Maximum.SendValue}
            index={selectedIndex}
            isSelected={recharges?.indexRechargeTN === index }
            handleSelect={()=> handleSelect(item, index)}
            onSelect={setSelectedIndex}
            />
          </div>
          
        )}
        )}
      </div>
      <div className={` sm:bg-white flex justify-center py-6 sm:py-3 gap-4 font-bold`}>
        <button
          className={classNames( 'text-[18px]  border  text-[#5754E5]  h-[56px] w-[140px]  border-[#5754E5] rounded-[16px]' )}
           onClick={onBackChangeStep}
        >
          Précédent
        </button>
        <button
          className={classNames(
            'text-[18px] text-[#FFF] w-[357px] h-[56px] rounded-xl   sm:w-[180px]',
            (selectedIndex != -1)  ?   'bg-[#5754E5] ' : 'bg-[#D1D1FF]',
          )}
           onClick={() => {
            if (statusComplete) {
               onChangeStep()
              functionTracks('2')
              // setIndexxx(selectedIndex)
              FNPayer()
            } else if (statusPending) {
              openModalStatus()
            } else if (statusNotFound) {
              navigate('/personalinformation')
            }
           }}
          disabled={selectedIndex === -1}
        >
          Suivant
        </button>
      </div>
        <ModalTestStatusUser
           isOpen={openIsModalStatus}
           closeModal={closeModalStatus}
           statusPending={statusPending}
           statusNotFound={statusNotFound}
        />
    </div>
  )
}

export default OffreRecharge
